import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule, FieldArrayType } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div class="repeat-section">
      @for (field of field.fieldGroup; track field.id) {
      <p-card class="repeat-item-card">
        <div class="remove-button-wrapper">
          <p-button
            type="button"
            icon="pi pi-times"
            styleClass="p-button-danger p-button-text p-button-sm"
            (onClick)="remove($index)"
          ></p-button>
        </div>
        <formly-field [field]="field"></formly-field>
      </p-card>
      }
      <p-button
        type="button"
        icon="pi pi-plus"
        styleClass="p-button-secondary add-button"
        (onClick)="add()"
      ></p-button>
    </div>
  `,
  styleUrls: ['./formly-repeat-section.component.scss'],
  imports: [CommonModule, FormlyModule, FormlyPrimeNGModule, ButtonModule, CardModule],
})
export class FormlyRepeatSectionComponent extends FieldArrayType {}

